import './sentry-config';
import { createRoot } from 'react-dom/client';
import { lazy, Suspense } from 'react';
import { KcPage, type KcContext } from './keycloak-theme/kc.gen';

const AppEntrypoint = lazy(() => import('./main.app'));

// To build the Keycloak theme with Keycloakify, the main.tsx file needs to load the KcPage component.
// Ideally, the Keycloak theme should be a separate subproject (e.g., apps/keycloak-theme).
// However, this would break references to components until they are moved to their own subproject.
// For more details, refer to the documentation: https://docs.keycloakify.dev/integration-keycloakify-in-your-codebase/vite

createRoot(document.getElementById('root')!).render(
  <>
    {window.kcContext ? (
      <KcPage kcContext={window.kcContext} />
    ) : (
      <Suspense>
        <AppEntrypoint />
      </Suspense>
    )}
  </>,
);

declare global {
  interface Window {
    kcContext?: KcContext;
  }
}
